import { PenTool, Package, Stethoscope, Headset, FileText, Users, ShieldCheck, Clock } from "lucide-react";
import { SERVICES } from "@/data/content";
import { Reveal, MaskedLines, Eyebrow } from "./Reveal";

const ICONS = { PenTool, Package, Stethoscope, Headset, FileText, Users, ShieldCheck, Clock };

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-white py-28 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <Reveal><Eyebrow n="03" label="Services" /></Reveal>
      <MaskedLines
        as="h2"
        inView
        delay={0.1}
        className="mt-6 max-w-3xl font-display text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl lg:text-5xl"
        lines={["Everything a US business", "shouldn't have to do in-house."]}
      />

      <div className="mt-16 grid gap-4 lg:grid-cols-12">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={0.06 * (i % 3)} className={s.span}>
              <div
                data-testid={`service-card-${i + 1}`}
                className="group relative h-full overflow-hidden rounded-[1.5rem] border border-brand-indigo/10 bg-brand-ice p-7 transition-colors duration-500 hover:border-transparent hover:bg-brand-navy sm:p-9"
              >
                <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full opacity-0 blur-3xl transition-opacity duration-700 group-hover:opacity-40" style={{ background: s.accent }} />
                <div className="relative flex items-start justify-between">
                  <span className="grid h-12 w-12 place-items-center rounded-2xl bg-white text-brand-indigo shadow-sm transition-colors duration-500 group-hover:bg-white/10 group-hover:text-brand-cyan">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-indigo/60 transition-colors duration-500 group-hover:text-white/50">{s.brand}</span>
                </div>
                <h3 className="relative mt-8 font-display text-xl font-semibold tracking-tight text-brand-ink transition-colors duration-500 group-hover:text-white sm:text-2xl">{s.title}</h3>
                <p className="relative mt-3 max-w-md text-sm leading-relaxed text-slate-600 transition-colors duration-500 group-hover:text-white/65 sm:text-base">{s.body}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
